var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.215,
    height: 28.215,
    viewBox: "0 0 28.215 28.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Microsoft_logo",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162151",
    "data-name": "Path 162151",
    d: "M1,1H14.436V14.436H1Z",
    fill: "#f35325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162152",
    "data-name": "Path 162152",
    d: "M12,1H25.436V14.436H12Z",
    transform: "translate(3.779)",
    fill: "#81bc06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162153",
    "data-name": "Path 162153",
    d: "M1,12H14.436V25.436H1Z",
    transform: "translate(0 3.779)",
    fill: "#05a6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162154",
    "data-name": "Path 162154",
    d: "M12,12H25.436V25.436H12Z",
    transform: "translate(3.779 3.779)",
    fill: "#ffba08"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogo);
export default __webpack_public_path__ + "static/media/Microsoft-logo.28ac6e1f68836ddb9c4edbdc44071ff7.svg";
export { ForwardRef as ReactComponent };